/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
function e(e){let n=0;return e.some(({emissions:e})=>3===e||2===e&&1===n||1===e&&2===n?(n=3,!0):(0!==e&&0===n&&(n=e),!1)),n}export{e as getEmissions};
